import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  automation: [],
  addAutomationObjectName: null,
}

const curatorAutomationSlicer = createSlice({
  name: "curatorAutomation",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setAutomation: (state, { payload }) => {
      state.automation = payload;
    },
    addAutomation: (state, { payload }) => {
      state.automation.push(payload)
    },
    setAddAutomationObjectName: (state, { payload }) => {
      state.addAutomationObjectName = payload;
    },
    deleteAutomation: (state, { payload }) => {
      state.automation = state.automation.filter(md => md.title !== payload.title);
    },
    toggleEditAutomation: (state, { payload }) => {
      state.automation = state.automation.map(md => {
        return md.title === payload.title
          ? { ...md, edit: !md.edit }
          : md;
      });
    },
    setAutomationStatus: (state, { payload }) => {
      state.automation = state.automation.map(md => {
        return md.title === payload.title
          ? { ...md, status: payload.status }
          : md
      })
    },
    updateAutomationTitle: (state, { payload }) => {
      state.automation = state.automation = state.automation.map(md => {
        return md.title === payload.title
          ? { ...md, title: payload.newTitle }
          : md;
      });
    },
    changeAutomationOrder: (state, { payload }) => {
      const { title, destinationIndex } = payload
      const automationItem = state.automation.find(md => md.title === title);
      const reorderedBefore = destinationIndex < automationItem.sequenceNo

      state.automation = state.automation.map(md => {
        if (md.title === title) {
          return { ...md, sequenceNo: destinationIndex }
        }

        if (reorderedBefore) {
          if (automationItem.sequenceNo > md.sequenceNo && md.sequenceNo >= destinationIndex) {
            return { ...md, sequenceNo: md.sequenceNo + 1 }
          }
        } else {
          if (automationItem.sequenceNo < md.sequenceNo && md.sequenceNo <= destinationIndex) {
            return { ...md, sequenceNo: md.sequenceNo - 1 }
          }
        }

        return md;
      })
    }
    
  },
});

export const {
  setAutomation,
  addAutomation,
  deleteAutomation,
  toggleEditAutomation,
  updateAutomationTitle,
  changeAutomationOrder,
  setAutomationStatus,
  setAddAutomationObjectName,
} = curatorAutomationSlicer.actions;
export const curatorAutomationActions = curatorAutomationSlicer.actions;
export const actions = curatorAutomationSlicer.actions;

export const curatorAutomationSelector = (state) => state.curatorAutomation;
export const curatorAutomationReducer = curatorAutomationSlicer.reducer;
export default curatorAutomationReducer;

export const selectAddAutomationObjectName = (state) => state.curatorAutomation.addAutomationObjectName;
export const selectHasAutomation = (state) => state.curatorAutomation.automation.length > 0;
export const selectAutomationByTitle = (state, title) => state.curatorAutomation.automation.find(md => md.title === title);
export const selectAutomation = (state, title) => state.curatorAutomation.automation;